var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "06a431ea-d99e-4aa4-a71a-74169910de90"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "09490849-8b97-47b6-b263-135ad50bdde4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 12.39 -12.39 0 583.43 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -52)",
    d: "M 80.738 22.116 L 19.262 22.116 C 16.679000000000002 22.116 14.61 24.184 14.61 26.77 L 14.61 63.428 C 14.61 65.961 16.68 68.08 19.262 68.08 L 45.218 68.08 L 61.55500000000001 81.88499999999999 L 55.402 68.08 L 80.738 68.08 C 83.271 68.08 85.39 65.961 85.39 63.428 L 85.39 26.77 C 85.391 24.184 83.271 22.116 80.738 22.116 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -12.39 12.39 0 498.14 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -52)",
    d: "M 80.738 22.116 L 19.262 22.116 C 16.679000000000002 22.116 14.61 24.184 14.61 26.77 L 14.61 63.428 C 14.61 65.961 16.68 68.08 19.262 68.08 L 45.218 68.08 L 61.55500000000001 81.88499999999999 L 55.402 68.08 L 80.738 68.08 C 83.271 68.08 85.39 65.961 85.39 63.428 L 85.39 26.77 C 85.391 24.184 83.271 22.116 80.738 22.116 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 557.57 522.26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,37,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-263.99, -255.99)",
    d: "M 463.5 224 L 472 224 C 485.3 224 496 213.3 496 200 L 496 72 C 496 62.3 490.2 53.5 481.2 49.8 C 472.2 46.099999999999994 461.9 48.099999999999994 455 55 L 413.4 96.6 C 325.79999999999995 10.099999999999994 184.7 10.399999999999991 97.59999999999997 97.6 C 10.099999999999966 185.1 10.099999999999966 326.9 97.59999999999997 414.4 C 185.09999999999997 501.9 326.9 501.9 414.4 414.4 C 426.9 401.9 426.9 381.59999999999997 414.4 369.09999999999997 C 401.9 356.59999999999997 381.59999999999997 356.59999999999997 369.09999999999997 369.09999999999997 C 306.59999999999997 431.59999999999997 205.29999999999995 431.59999999999997 142.79999999999995 369.09999999999997 C 80.29999999999995 306.59999999999997 80.29999999999995 205.29999999999995 142.79999999999995 142.79999999999995 C 204.99999999999994 80.59999999999995 305.49999999999994 80.29999999999995 368.09999999999997 141.79999999999995 L 327 183 C 320.1 189.9 318.1 200.2 321.8 209.2 C 325.5 218.2 334.3 224 344 224 L 463.5 224 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.a0230042a05de32c960ab65070a9a9a1.svg";
export { ForwardRef as ReactComponent };